import { config } from "@repo/config";
import { NotificationPreferencesForm } from "@saas/settings/components/NotificationPreferencesForm";
import { SettingsPageIntro } from "@saas/settings/components/SettingsLayout";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_saas/app/_account/settings/notifications",
)({
	head: () => ({ meta: [{ title: `Notifications - ${config.appName}` }] }),
	component: NotificationSettingsPage,
});

function NotificationSettingsPage() {
	return (
		<>
			<SettingsPageIntro title="Notifications" />
			<NotificationPreferencesForm />
		</>
	);
}
